import { articles } from "@/mocks/articles";
import { topics } from "@/mocks/topics";

export type Article = (typeof articles)[number];
export type Topic = (typeof topics)[number];

export function formatHeat(heat: number): string {
  if (heat >= 10000) {
    return `${(heat / 10000).toFixed(1)}万`;
  }
  return `${heat}`;
}

export function sortByLatest<T extends { publishedAt: string; time: string }>(list: T[]): T[] {
  return [...list].sort((a, b) => `${b.publishedAt} ${b.time}`.localeCompare(`${a.publishedAt} ${a.time}`));
}

export function getAllArticles(): Article[] {
  return articles;
}

export function getHeadline(): Article {
  return articles.find((a) => a.isHeadline) ?? articles[0];
}

export function getArticleBySlug(slug: string): Article | undefined {
  return articles.find((a) => a.slug === slug);
}

export function getArticlesByTopic(topicSlug: string): Article[] {
  return articles.filter((a) => a.topic === topicSlug);
}

export function getTopicBySlug(slug: string): Topic | undefined {
  return topics.find((t) => t.slug === slug);
}

export function getRelated(article: Article, count = 3): Article[] {
  const sameTopic = articles.filter((a) => a.slug !== article.slug && a.topic === article.topic);
  const others = articles.filter((a) => a.slug !== article.slug && a.topic !== article.topic);
  return [...sameTopic, ...sortByLatest(others)].slice(0, count);
}

export function searchArticles(query: string): Article[] {
  const q = query.trim().toLowerCase();
  if (!q) return [];
  return articles.filter(
    (a) =>
      a.title.toLowerCase().includes(q) ||
      a.summary.toLowerCase().includes(q) ||
      a.topicName.toLowerCase().includes(q) ||
      a.tags.some((t) => t.toLowerCase().includes(q))
  );
}